// @ts-nocheck
import wowImageFactory from './WowImage';
export default function init(contextWindow) {
    const elementName = 'wow-image';
    contextWindow = contextWindow || window;
    if (contextWindow.customElements.get(elementName) === undefined) {
        let resizeObserver;
        if (contextWindow.ResizeObserver) {
            resizeObserver = new contextWindow.ResizeObserver((entries) => {
                entries.map((entry) => entry.target.reLayout());
            });
        }
        return function (services, env) {
            const WowImage = wowImageFactory(Object.assign({ resizeService: resizeObserver }, services), env, contextWindow);
            contextWindow.customElements.define(elementName, WowImage);
        };
    }
    return;
}
//# sourceMappingURL=registry.js.map